module.exports = __webpack_public_path__ + "static/3-a677d59501b98a9e84f40806d9d3077b.jpg";